import { createContext } from 'react';
import { ValidationMode } from '@e2m-customer-portal/shared';

export interface ValidationContextProps {
  /**
   * The validation mode for any input fields that are part of this context.
   */
  mode: ValidationMode;

  /**
   * Any input fields should call this function whenever they change. This is done so the context can determine if
   * all associated inputs are valid. The id or name of the input must be unique within the context.
   * @param id
   * @param valid
   */
  onChange: (id: string, valid: boolean) => void;
}

const defaultValidationContext: ValidationContextProps = {
  mode: 'blur',
  onChange: () => undefined,
};

export const ValidationContext = createContext<ValidationContextProps>(defaultValidationContext);

ValidationContext.displayName = 'ValidationContext';
